if (!customElements.get("variant-picker")) {
  class t extends HTMLElement {
    constructor() {
      super(),
        Shopify.designMode ? setTimeout(() => this.init(), 200) : this.init();
    }
    init() {
      (this.selectors = {
        error: ".m-product-form-message",
        variantIdInput: '[name="id"]',
        pickerFields: ["[data-picker-field]"],
        optionNodes: [".m-product-option--node"],
        productSku: "[data-variant-sku]",
        productAvailability: "[data-availability]",
        shareUrlInput: "[data-share-url]",
        stockCountdown: ".prod__stock-countdown",
        productWrapper: ".m-main-product--wrapper",
      }),
        (this.productWrapper = this.closest(this.selectors.productWrapper)),
        (this.productForm = this.productWrapper.querySelector("product-form")),
        (this.domNodes = queryDomNodes(this.selectors, this.productWrapper));
      const t = window._themeProducts || {},
        {
          productId: e,
          sectionId: a,
          productUrl: i,
          hasOnlyDefaultVariant: r,
          showFeaturedMedia: s,
        } = this.dataset;
      (this.productId = e),
        (this.sectionId = a),
        (this.productUrl = i),
        (this.hasOnlyDefaultVariant = "true" === r),
        (this.showFeaturedMedia = "true" === s),
        (this.variantData = this.getVariantData()),
        (this.productData = Object.assign(this.getProductJson(), t[e])),
        this.handleQueryString(),
        this.handleVariantGroupImages(),
        this.selectInitialVariant(),
        this.setupEventListeners(),
        this.initOptionSwatches();
    }
    handleQueryString() {
      const t = window.location.search.includes("?variant=");
      (this.selectedVariantDefault =
        "true" === this.dataset.disableSelectedVariantDefault &&
        this.productData &&
        this.productData.variants.length > 1 &&
        !t),
        this.selectedVariantDefault && this.disableSelectedVariantDefault();
    }
    handleVariantGroupImages() {
      (this.enableVariantGroupImages =
        "true" === this.dataset.enableVariantGroupImages),
        this.enableVariantGroupImages &&
          (this.variantGroupImages = this.getVariantGroupImageData());
    }
    selectInitialVariant() {
      this.selectedVariant = this.productWrapper.querySelector(
        this.selectors.variantIdInput
      );
      const t = Number(this.selectedVariant.value);
      (this.currentVariant = this.productData.variants.find((e) => e.id === t)),
        (this.productData.current_variant_id =
          this.currentVariant && this.currentVariant.id),
        (this.productData.initialVariant = this.currentVariant),
        this.currentVariant &&
          (this.getDataImageVariant(this.currentVariant.id),
          this.hideSoldOutAndUnavailableOptions(),
          this.updateButton(!this.currentVariant.available));
    }
    setupEventListeners() {
      const t = () => this.getMediaGallery();
      t(),
        document.addEventListener("matchMobile", t),
        document.addEventListener("unmatchMobile", t),
        this.addEventListener("change", this.onVariantChange);
    }
    async getMediaGallery() {
      await this.waitForMediaGallery(), this.setupMediaGallery();
    }
    waitForMediaGallery() {
      return new Promise((t) => {
        const e = () => {
          (this.mediaGallery =
            this.productWrapper.querySelector("media-gallery")),
            (this.mediaGalleryMobile = this.productWrapper.querySelector(
              "media-gallery-mobile"
            )),
            this.mediaGallery || this.mediaGalleryMobile
              ? t()
              : setTimeout(e, 100);
        };
        e();
      });
    }
    setupMediaGallery() {
      const t = MinimogTheme.config.mqlMobile,
        e = (t && this.mediaGalleryMobile) || this.mediaGallery;
      (this.media = e),
        t || "slider" === e.mediaMode
          ? ((this.slides = e.slider && e.slider.slides),
            (this.slidesNav = e.navSlider && e.navSlider.slides))
          : (this.mediaItems = e.querySelectorAll(".m-product-media--item")),
        (this.layout = t ? void 0 : e.layout),
        (!this.showFeaturedMedia ||
          (this.enableVariantGroupImages && this.variantGroupImages.enable)) &&
          this.updateMedia();
    }
    disableSelectedVariantDefault() {
      this.querySelectorAll('input[type="radio"]').forEach((t) => {
        t.checked = !1;
      }),
        this.querySelectorAll("[data-picker-field='radio']").forEach((t) => {
          t.setAttribute("data-selected-value", "");
        }),
        this.querySelectorAll("[data-picker-field='select']").forEach((t) => {
          const e = t.querySelector("select");
          e && (e.value = ""), t.setAttribute("data-selected-value", "");
        }),
        this.querySelectorAll(".option-label--selected").forEach((t) => {
          t.textContent = "";
        });
      const t =
        this.productForm && this.productForm.querySelector("[name='id']");
      t && !this.hasOnlyDefaultVariant && (t.value = "");
    }
    setProductAsUnavailable() {
      this.updateButton(!0), this.setUnavailable();
    }
    updateProductDetailsForVariant() {
      this.getDataImageVariant(this.currentVariant.id),
        this.updateMedia(),
        this.updateBrowserHistory(),
        this.updateVariantInput(),
        this.updateProductMeta(),
        this.updatePrice();
      const t = !this.currentVariant.available,
        e = t ? window.MinimogStrings.soldOut : "";
      this.updateButton(t, e), this.hideSoldOutAndUnavailableOptions();
    }
    onVariantChange() {
      this.getSelectedOptions(),
        this.getSelectedVariant(),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.currentVariant
          ? (this.updateProductDetailsForVariant(),
            window.MinimogEvents.emit(
              `${this.productId}__VARIANT_CHANGE`,
              this.currentVariant,
              this
            ))
          : this.setProductAsUnavailable();


      if (document.querySelectorAll(".main-product__block-free-product .gift-item").length) {
        const checkbox_subsruption = document.getElementById('ppCheckbox');
        var currentVariant = this.currentVariant;
        var getselectedvariant = document.querySelector(".main-product__block-variant_picker input[type='radio']:checked").getAttribute("data-variant-title").split("")[0];
        var variantStrToNum = Number(getselectedvariant);
        // var subscriptionIsActive = !checkbox_subsruption.classList.contains("unchecked");

        // Assume you already have these
        const variantname = variantStrToNum; // e.g. 1, 2, or 3
        const subscriptionIsActive = !checkbox_subsruption.classList.contains("unchecked");
        
        // Determine how many gifts are allowed based on logic
        let allowedGifts = 0;
        
        if (document.body.classList.contains("shape-harmonie-gummies")) {
          if (subscriptionIsActive) {
            if (variantname === 3 || variantname === 2) {
              allowedGifts = 4;
            } else if (variantname === 1) {
              allowedGifts = 4;
            }
          } else {
            if (variantname === 3) {
              allowedGifts = 2;
            } else if (variantname === 2) {
              allowedGifts = 1;
            } else {
              allowedGifts = 0;
            }
          }
        } else {
          if (subscriptionIsActive) {
            if (variantname === 3 || variantname === 2) {
              allowedGifts = 4;
            } else if (variantname === 1) {
              allowedGifts = 3;
            }
          } else {
            if (variantname === 3) {
              allowedGifts = 2;
            } else if (variantname === 2) {
              allowedGifts = 1;
            } else {
              allowedGifts = 0;
            }
          }
        }
        
        let addedGifts = 0;
        var freeProductId = "";
        const uniqueId = generateUniqueId();
        document.querySelectorAll(".main-product__block-free-product").forEach(rawItem => {
          rawItem.querySelectorAll(".main-product__block-free-product .gift-item").forEach(item => {
            if (item.getAttribute("data-condition")) {
              const conditions = item.getAttribute("data-condition").split(",");
              
              // check if current gift item satisfies any valid condition
              let isValid = conditions.some(condition => {
                const [qty, subType] = condition.split("-");
                const isSub = subType === "subscription" || subType === "subskrypcja" || subType === "subskrypcje" || subType === "abonamentowy";
                return parseInt(qty) === variantname && isSub === subscriptionIsActive;
              });
            
              if (isValid && (addedGifts < allowedGifts || document.body.classList.contains("horizon-variant-product"))) {
                item.classList.remove("is-unavailable");
                item.querySelector(".gift_card").classList.add("is-active");
                item.querySelector(".gift-overlay").classList.add("is-active");
                item.querySelectorAll("input[type='hidden']").forEach(input => {
                  input.removeAttribute("disabled");
                });
                freeProductId += ("," + item.getAttribute("data-product-id"));
                addedGifts++;
              } else {
                item.classList.add("is-unavailable");
                item.querySelector(".gift_card").classList.remove("is-active");
                item.querySelector(".gift-overlay").classList.remove("is-active");
                item.querySelectorAll("input[type='hidden']").forEach(input => {
                  input.setAttribute("disabled", "disabled");
                });
              }
              // item.querySelector(".unique-id-child").value = uniqueId;
            }
          });
        });
        
        const addToCartBtn = document.querySelector('.m-add-to-cart');
        const inputToRemove = document.querySelector('#custom_info');
        if (inputToRemove) {
          inputToRemove.remove();
        }

        if (addToCartBtn) {
          // Create a new hidden input
          // const hiddenInput = document.createElement('input');
          // hiddenInput.type = 'hidden';
          // hiddenInput.name = 'properties[_unique-id]';  // Change this to whatever name you need
          // hiddenInput.id = 'custom_info';  // Change this to whatever name you need
          // hiddenInput.value = uniqueId;  // Set your value here
          
          // // Insert it after the .m-add-to-cart element
          // addToCartBtn.insertAdjacentElement('afterend', hiddenInput);
        }
      }
      setTimeout(() => {
        const varCheckbox = document.querySelector(".pp_var_checkbox");
        const checkbox = document.querySelectorAll(".loop-w-btn-group-purchase-option").length;

        if (!checkbox || !varCheckbox) return;

        const isUnchecked = varCheckbox.classList.contains("unchecked");

        if (isUnchecked) {
          const element = document.querySelector(".loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-onetime");
          const clickEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          });

          element.dispatchEvent(clickEvent);
        } else {
          const element = document.querySelector(".loop-w-btn-group-purchase-option:not(.loop-w-btn-group-purchase-option-onetime)");
          const clickEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
          });

          element.dispatchEvent(clickEvent);
        }
      }, 500);

    }
    getDataImageVariant(t) {
      if (!this.variantGroupImages || !this.variantGroupImages.enable) return;
      const e = this.variantGroupImages.mapping.find((e) => Number(e.id) === t);
      e && (this.currentVariantMedia = e.media);
    }
    getProductJson() {
      try {
        const t = this.productWrapper.querySelector(
          "#productData[type='application/json']"
        );
        if (!t) throw new Error("Fallback product data element not found.");
        return JSON.parse(t.textContent);
      } catch (t) {}
    }
    getSelectedVariant() {
      let t,
        e = [...this.options];
      for (
        let a = 0;
        a < this.options.length &&
        ((t = getVariantFromOptionArray(this.productData, e)),
        !t && 0 !== e.length);
        a++
      )
        e.pop();
      t && ((this.options = [...t.options]), this.updateSelectedOptions()),
        (this.currentVariant = t);
      // Added By A...
      this.querySelectorAll('.m-product-option--node').forEach((item) => {
        var val = item.getAttribute('data-value');
        
        if (this.currentVariant && this.currentVariant.title === val) {
          const offPercentageElement = item.querySelector('.off_percentage');
          item.classList.add('active')
          if (offPercentageElement) {
            offPercentageElement.classList.add("active-offer");
          }
        } else {
          item.classList.remove('active')
          const offPercentageElement = item.querySelector('.off_percentage');
          if (offPercentageElement) {
            offPercentageElement.classList.remove("active-offer");
          }
        }
      });

    }
    getSelectedOptions() {
      const t = Array.from(this.querySelectorAll("[data-picker-field]"));
      this.options = t
        .map((t) => {
          if ("radio" === t.dataset.pickerField) {
            const e = t.querySelector("input:checked");
            return e ? e.value : void 0;
          }
          if (t.querySelector("select")) return t.querySelector("select").value;
        })
        .filter((t) => void 0 !== t);
    }
    updateSelectedOptions() {
      this.domNodes.pickerFields.forEach((t, e) => {
        if (t.dataset.selectedValue !== this.options[e]) {
          const a = t.querySelector(
            `input[value="${this.options[e].replace(/["\\]/g, "\\$&")}"]`
          );
          a && ((a.checked = !0), t.updateSelectedValue());
        }
      });
    }
    removeLoading(t) {
      t &&
        (t.removeAttribute("data-media-loading"),
        (t.firstElementChild.style.opacity = 1));
    }
    handleImageZoom(t, e) {
      const a = t.map((t) => {
        const e = t.dataset.mediaType;
        if ("image" === e) {
          const e = t.querySelector(".m-product-media").dataset;
          return {
            src: e.mediaSrc,
            width: parseInt(e.mediaWidth),
            height: parseInt(e.mediaHeight),
            alt: e.mediaAlt,
            id: t.dataset.index,
          };
        }
        return {
          html: `<div class="pswp__${e}">${t.innerHTML}</div>`,
          type: e,
          id: t.dataset.index,
        };
      });
      e &&
        e.lightbox &&
        (e.lightbox.destroy(), e.handlePhotoswipe(a), e.initPhotoswipe());
    }
    updateMedia() {
      if (!this.currentVariant) return;
      let t = [],
        e = [];
      const a = (t, e, a = !1, i = !1) => {
          let r = [];
          return (
            t.forEach((t, a) => {
              const i = e.find(
                (e) => e.querySelector("[data-media-id]").dataset.mediaId === t
              );
              i &&
                ((i.dataset.index = a),
                (i.dataset.swiperSlideIndex = a),
                r.push(i));
            }),
            e.forEach((e) => {
              const a = e.querySelector("[data-media-id]").dataset.mediaId;
              t.includes(a) ||
                r.includes(e) ||
                ((e.dataset.index = r.length),
                (e.dataset.swiperSlideIndex = r.length),
                r.push(e));
            }),
            i &&
              r.forEach((t) => {
                a
                  ? t.classList.toggle(
                      "swiper-slide-thumb-active",
                      "0" === t.dataset.swiperSlideIndex
                    )
                  : t.classList.toggle(
                      "swiper-slide-active",
                      "0" === t.dataset.swiperSlideIndex
                    );
              }),
            r
          );
        },
        i = (t, e) => {
          t.forEach((t) => {
            const a = t.querySelector("[data-media-id]").dataset.mediaId,
              i =
                this.currentVariantMedia &&
                this.currentVariantMedia.length > 0 &&
                this.currentVariantMedia.includes(a),
              r = !t.classList.contains("media-type-image");
            (i ||
              r ||
              !this.currentVariantMedia ||
              0 === this.currentVariantMedia.length) &&
              e.push(t);
          });
        };
      if (this.variantGroupImages && this.variantGroupImages.enable)
        if ("slider" === this.media.mediaMode && this.slides) {
          i(this.slides, t);
          const r = a(this.currentVariantMedia, t, !1, !0);
          if (
            (this.media.slider.removeAllSlides(),
            this.media.slider.appendSlide(r),
            this.media.slider.slideToLoop("layout-7" === this.layout ? 1 : 0),
            this.media.handleSlideChange(),
            this.slidesNav)
          ) {
            i(this.slidesNav, e);
            const t = a(this.currentVariantMedia, e, !0, !0);
            this.media.navSlider && this.media.navSlider.removeAllSlides(),
              this.media.navSlider && this.media.navSlider.appendSlide(t),
              this.media.navSlider && this.media.navSlider.slideToLoop(0);
          }
        } else {
          const e = this.media.querySelector(".m-product-media--list");
          if (!e) return;
          i(this.mediaItems, t);
          const r = a(this.currentVariantMedia, t);
          (e.innerHTML = ""),
            r.forEach((t, a) => {
              "layout-2" === this.layout &&
                (t.classList.remove("m-col-span-2"),
                a % 3 == 0 && t.classList.add("m-col-span-2")),
                e.append(t);
            });
        }
      else {
        let t = 0;
        this.media &&
          "mediaSize" in this.media.dataset &&
          (t = parseInt(this.media.dataset.mediaSize, 10)),
          t > 0 && this.media.setActiveMedia(this.currentVariant);
      }
      this.removeLoading(this.media), this.handleImageZoom(t, this.media);
    }
    updateBrowserHistory() {
      if (window.location.href.includes("/products")) { 
      this.currentVariant &&
        "false" !== this.dataset.updateUrl &&
        window.history.replaceState(
          {},
          "",
          `${this.productUrl}?variant=${this.currentVariant.id}`
        );
      }
        var currentVariantId = this.currentVariant.id;
        document.querySelectorAll(".m-product-option .variant-id").forEach(function(item) {
            item.value = currentVariantId;
        })
    }
    updateVariantInput() {
      document
        .querySelectorAll(
          `#product-form-${this.sectionId}, #product-form-installment`
        )
        .forEach((t) => {
          const e = t.querySelector(this.selectors.variantIdInput);
          e &&
            ((e.value = this.currentVariant.id),
            e.dispatchEvent(new Event("input", { bubbles: !0 })));
        });
    }
    updatePickupAvailability() {
      const t = this.productWrapper.querySelector("pickup-availability");
      t && this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : t && (t.removeAttribute("available"), (t.innerHTML = ""));
    }
    removeErrorMessage() {
      const t = this.closest("section");
      if (!t) return;
      const e = t.querySelector("product-form");
      e && e.handleErrorMessage();
    }
    updatePrice() {
      const t = "m-price--on-sale",
        e = "m-price--sold-out",
        a = this.productWrapper.querySelector(".main-product__block-price");


      
        var eleSalePrice = 0;
        var atcPrice = this.currentVariant.price;
        var atcComparePrice = this.currentVariant.compare_at_price;
        var priceElement = this.closest(".shopify-section").querySelector('.m-add-to-cart--price');
        var comparePriceElement = this.closest(".shopify-section").querySelector('.m-add-to-cart-compare-price');
      
          // if (priceElement) {
          //   priceElement.innerHTML = formatMoney(atcPrice,window.MinimogSettings.money_format);
          //   priceElement.setAttribute('data-price', atcPrice);
          // }
          // if (comparePriceElement) {
          //   comparePriceElement.innerHTML = formatMoney(atcComparePrice,window.MinimogSettings.money_format);
          //   comparePriceElement.setAttribute('data-price', atcComparePrice);
          // }          
      

        if (window.location.href.includes("/products")) {
          // for loop subscription code ================
          console.log(this,'this');
          var selected_value = this.closest(".shopify-section").querySelector(".loop-w-btn-group-purchase-options-container .loop-w-btn-group-purchase-option.loop-w-btn-group-purchase-option-selected");
          var priceElementGetPrice = this.closest(".shopify-section").querySelector('.m-add-to-cart--price') ? this.closest(".shopify-section").querySelector('.m-add-to-cart--price').getAttribute("data-price") : 0;


          if (selected_value) {
            if (selected_value.classList.contains('loop-w-btn-group-purchase-option-onetime')) {
              var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-price"));
              var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
              this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach(element => {
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"),window.MinimogSettings.money_format);
              });
              if (discounted_custom_price == discounted_custom_compare_price) {
                this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
                  element.style.display = "none";
                  element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
                });
              } else {
                this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
                  element.style.display = "block";
                  element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
                });
              }
            } else {
              var discounted_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"));
              var discounted_custom_compare_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
              this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart--price,.custom-product-price .price-item--sale").forEach(element => {
                element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-subscription-price"),window.MinimogSettings.money_format);
              });
              if (discounted_custom_price == discounted_custom_compare_price) {
                this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
                  element.style.display = "none";
                  element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
                });
              } else {
                this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
                  element.style.display = "block";
                  element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
                });
              }
            }
          }

          this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper.non-sub-price .m-add-to-cart--price").forEach(element => {
            element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-price"),window.custom_formate_money_no_decimals);
          });

          // this.closest(".shopify-section").querySelectorAll(".m-add-to-cart--price-wrapper .m-add-to-cart-compare-price,.custom-product-price .m-price-item--regular").forEach(element => {
          //   element.innerHTML = formatMoney(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"),window.MinimogSettings.money_format);
          // });
          if (document.querySelector('.custom-price__badge-sale .m-product-tag')) {
            let original_custom_price = Number(document.querySelector(".m-product-option--node.active").getAttribute("data-compar-at-price"));
            const custom_discount = (((original_custom_price - discounted_custom_price) / original_custom_price) * 100).toFixed(0);
            document.querySelector('.custom-price__badge-sale .m-product-tag').innerHTML = `Sparen Sie ${custom_discount}%`
          }
        
        
          if (selected_value != null) {
            const getPR = getSavePercent(atcComparePrice, eleSalePrice);
            if (this.closest(".shopify-section").querySelector("[data-saved-price]")) { 
              this.closest(".shopify-section").querySelector("[data-saved-price]").innerHTML = `${getPR}%`
            }
          }else {
            // if (priceElement) {
            //   priceElement.innerHTML = formatMoney(atcPrice,window.MinimogSettings.money_format);
            //   priceElement.setAttribute('data-price', atcPrice);
            // }
            // if (comparePriceElement) {
            //   comparePriceElement.innerHTML = formatMoney(atcComparePrice,window.MinimogSettings.money_format);
            //   comparePriceElement.setAttribute('data-price', atcComparePrice);
            // }          
          }
          console.log(selected_value,'selected_value');
        } else {
          const container = this.closest('.m-main-product--info');
          var priceElement = this.closest(".shopify-section").querySelector(".m-add-to-cart--price");
          var priceElementGetPrice = this.closest(".shopify-section").querySelector(".m-add-to-cart--price") ? this.closest(".shopify-section").querySelector(".m-add-to-cart--price").getAttribute("data-price") : 0;
          if (document.getElementById('ppCheckbox').classList.contains("unchecked")) {
            container.classList.remove('subscription-select');
            container.classList.add('onetime-select');
            // if (priceElement) {
            //   priceElement.innerHTML = formatMoney(priceElementGetPrice,window.MinimogSettings.money_format);
            // }
            this.closest(".shopify-section").querySelectorAll(".variant-price .subsription-price").forEach((el) => (el.style.display = "none"));
            this.closest(".shopify-section").querySelectorAll(".variant-price .main-price").forEach((el) => (el.style.display = "block"));
            this.closest(".shopify-section").querySelectorAll(".variant-price-per-day .per-day-subsription").forEach((el) => (el.style.display = "none"));
            this.closest(".shopify-section").querySelectorAll(".variant-price-per-day .per-day-onetime").forEach((el) => (el.style.display = "block"));
            this.closest(".shopify-section").querySelectorAll(".variant-bottom-text").forEach((el) => (el.style.display = "none"));
          } else {
            container.classList.add('subscription-select');
            container.classList.remove('onetime-select');
            var priceElementQuantity = 1;
            if (this.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title")) {
              var priceElementQuantity = this.closest(".shopify-section").querySelector(".m-product-option--node.active .top-title").getAttribute("data-variant-title").split("")[0];
            }
            // var minusPrice = 500 * Number(priceElementQuantity);
            // if (priceElement) {
            //   priceElement.innerHTML = formatMoney(Number(priceElementGetPrice) - minusPrice,window.MinimogSettings.money_format);
            // }
            this.closest(".shopify-section").classList.add("subscription_select");
            this.closest(".shopify-section").querySelectorAll(".variant-price .subsription-price").forEach((el) => (el.style.display = "block"));
            this.closest(".shopify-section").querySelectorAll(".variant-price .main-price").forEach((el) => (el.style.display = "none"));
            this.closest(".shopify-section").querySelectorAll(".variant-price-per-day .per-day-subsription").forEach((el) => (el.style.display = "block"));
            this.closest(".shopify-section").querySelectorAll(".variant-price-per-day .per-day-onetime").forEach((el) => (el.style.display = "none"));
            this.closest(".shopify-section").querySelectorAll(".variant-bottom-text").forEach((el) => (el.style.display = "block"));
          }
        }

      
      if (true) return;
      const i = window.MinimogSettings.money_format,
        {
          priceWrapper: r,
          salePrice: s,
          unitPrice: n,
          compareAtPrice: o,
          saleBadge: d,
          saleAmount: l,
          unitPriceWrapper: c,
        } = queryDomNodes(
          {
            priceWrapper: ".m-price",
            salePrice: ".m-price-item--sale",
            compareAtPrice: [".m-price-item--regular"],
            unitPrice: ".m-price__unit",
            unitPriceWrapper: ".m-price__unit-wrapper",
            saleBadge: ".m-price__badge-sale",
            saleAmount: "[data-saved-price]",
          },
          a
        ),
        {
          compare_at_price: u,
          price: h,
          unit_price_measurement: p,
          available: m,
        } = this.currentVariant,
        v = r ? r.dataset.saleBadgeType : null,
        g = u && u > h,
        y = !m;
      if (
        (r?.classList.toggle(t, g),
        r?.classList.toggle(e, y),
        r?.classList.remove("m:visibility-hidden"),
        s && (s.innerHTML = formatMoney(h, i)),
        o &&
          o.forEach((t) => {
            const e = g ? u : h;
            t.innerHTML = formatMoney(e, i);
          }),
        d && g && "text" !== v)
      ) {
        let t;
        if ("fixed_amount" === v) t = formatMoney(u - h, i);
        else {
          t = Math.round((100 * (u - h)) / u) + "%";
        }
        l && (l.innerHTML = t);
      }
      if (p && n) {
        c?.classList.remove("m:hidden");
        const t = `<span>${formatMoney(
          this.currentVariant.unit_price,
          i
        )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
        n.innerHTML = t;
        
      } else c?.classList.add("m:hidden");
      var atcPrice = this.currentVariant.price;
      var atcComparePrice = this.currentVariant.compare_at_price;
      var priceElement = document.querySelector('.m-add-to-cart--price');
      var comparePriceElement = document.querySelector('.m-add-to-cart-compare-price');
      
      if (priceElement) {
          priceElement.innerHTML = formatMoney(atcPrice,window.MinimogSettings.money_format);
          priceElement.setAttribute('data-price', atcPrice);
        }
        if (comparePriceElement) {
          comparePriceElement.innerHTML = formatMoney(atcComparePrice,window.MinimogSettings.money_format);
          comparePriceElement.setAttribute('data-price', atcComparePrice);
      }

    }
    _getBaseUnit = () => {
      const { reference_value: t, reference_unit: e } =
        this.currentVariant.unit_price_measurement;
      return 1 === t ? e : `${t}${e}`;
    };
    updateButton(t = !0, e) {
      const a = document.querySelectorAll(`.product-form-${this.sectionId}`);
      a.length &&
        a.forEach((a) => {
          const i = a.querySelector('[name="add"]'),
            r = a.querySelector(".m-product-dynamic-checkout"),
            s = i.querySelector(".m-add-to-cart--text");
          if (!i) return;
          t
            ? (i.setAttribute("disabled", "disabled"),
              i.classList.add("disabled"),
              r && r.classList.add("disabled"),
              e && (s.textContent = e))
            : (i.removeAttribute("disabled"),
              i.classList.remove("disabled"),
              r && r.classList.remove("disabled"),
              (s.textContent = window.MinimogStrings.addToCart));
        });
    }
    updateProductMeta() {
      const { available: t, sku: e } = this.currentVariant,
        { inStock: a, outOfStock: i } = window.MinimogStrings,
        r = this.productWrapper.querySelector(
          this.selectors.productAvailability
        ),
        s = this.productWrapper.querySelector(this.selectors.productSku);
      s && (s.textContent = e || "N/A"),
        (() => {
          if (r) {
            const e = t ? "remove" : "add";
            (r.textContent = t ? a : i),
              r.classList[e]("m-product-availability--outofstock");
          }
        })();
    }
    setUnavailable() {
      const t = document.getElementById(`product-form-${this.sectionId}`),
        e = t ? t.querySelector('[name="add"]') : null,
        a = e ? e.querySelector(".m-add-to-cart--text") : null,
        i = this.productWrapper.querySelector(".m-price");
      e &&
        (a && (a.textContent = window.MinimogStrings.unavailable),
        i && i.classList.add("m:visibility-hidden"));
    }
    hideSoldOutAndUnavailableOptions() {
      const t = "m-product-option--node__soldout",
        e = "m-product-option--node__unavailable",
        { optionNodes: a } = this.domNodes,
        { variants: i, options: r } = this.productData;
      a.forEach((a) => {
        const { optionPosition: s, value: n } = a.dataset,
          o = Number(s),
          d = "OPTION" === a.tagName;
        let l = [];
        if (o === r.length) {
          const t = [...this.currentVariant.options];
          (t[o - 1] = n),
            l.push(getVariantFromOptionArray(this.productData, t));
        } else
          l = i.filter(
            (t) =>
              t.options[o - 1] === n &&
              t.options[o - 2] === this.currentVariant["option" + (o - 1)]
          );
        if (((l = l.filter(Boolean)), l.length)) {
          a.classList.remove(e), d && a.removeAttribute("disabled");
          const i = l.every((t) => !t.available) ? "add" : "remove";
          a.classList[i](t);
        } else a.classList.add(e), d && a.setAttribute("disabled", "true");
      });
    }
    getVariantData() {
      if (!this.variantData) {
        const t = this.querySelector(
          '#productVariants[type="application/json"]'
        );
        if (t)
          try {
            this.variantData = JSON.parse(t.textContent);
          } catch (t) {}
      }
      return this.variantData || {};
    }
    getVariantGroupImageData() {
      if (!this.variantGroupImages) {
        const t = this.querySelector('#variantGroup[type="application/json"]');
        if (t)
          try {
            this.variantGroupImages = JSON.parse(t.textContent);
          } catch (t) {}
      }
      return this.variantGroupImages || {};
    }
    initOptionSwatches() {
      const { _colorSwatches: t = [], _imageSwatches: e = [] } =
        window.MinimogSettings;
      this.domNodes.optionNodes &&
        this.domNodes.optionNodes.forEach((a) => {
          const { optionType: i, optionPosition: r, value: s } = a.dataset,
            n = s && s.toLowerCase(),
            o = this.variantData.find((t) => t[`option${r}`] === s),
            d =
              o && o.featured_image && o.featured_image.src
                ? getSizedImageUrl(o.featured_image.src, "100x")
                : null,
            l = e.find((t) => t.key === n),
            c = t.find((t) => t.key === n);
          if (d || (l && l.value)) {
            const t = a.querySelector("label");
            t && t.classList.add("has-bg-img");
          }
          const u = a.querySelector("label");
          if (u)
            switch ((u.classList.remove("option-loading"), i)) {
              case "default":
              case "image":
                u.style.backgroundImage = `url(${(l && l.value) || d || ""})`;
                break;
              case "color":
                (u.style.backgroundColor = (c && c.value) || n),
                  l && l.value && (u.style.backgroundImage = `url(${l.value})`);
            }
        });
    }
  }
  customElements.define("variant-picker", t);
}
if (!customElements.get("variant-button")) {
  class t extends HTMLElement {
    constructor() {
      super(),
        (this.selectedSpan = this.querySelector(".option-label--selected")),
        this.addEventListener("change", this.updateSelectedValue);
    }
    updateSelectedValue() {
      (this.value = Array.from(this.querySelectorAll("input")).find(
        (t) => t.checked
      ).value),
        this.setAttribute("data-selected-value", this.value),
        this.selectedSpan &&
          ((this.selectedSpan.textContent = this.value),
          this.selectedSpan.classList.remove("m:text-color-error"));
    }
  }
  if (
    (customElements.define("variant-button", t),
    !customElements.get("variant-select"))
  ) {
    class e extends t {
      constructor() {
        super();
      }
      updateSelectedValue() {
        (this.value = this.querySelector("select").value),
          this.setAttribute("data-selected-value", this.value),
          this.selectedSpan &&
            ((this.selectedSpan.textContent = this.value),
            this.selectedSpan.classList.remove("m:text-color-error"));
      }
    }
    customElements.define("variant-select", e);
  }
  if (!customElements.get("variant-image")) {
    class e extends t {
      constructor() {
        super();
      }
    }
    customElements.define("variant-image", e);
  }
  if (!customElements.get("variant-color")) {
    class e extends t {
      constructor() {
        super();
      }
    }
    customElements.define("variant-color", e);
  }
}

// $(document).ready(function () {
//     $(".horizon-product__block-free-product .main-product__block-free-product").hide();
//     $(".horizon-product__block-free-product .free-product-heading").on("click", function () {
//         const $heading = $(this);
//         const $content = $heading.next(".main-product__block-free-product");
//         if ($content.is(":visible")) {
//             $heading.removeClass("active");
//             $content.stop(true, true).slideUp(600);
//         } else {
//             $(".horizon-product__block-free-product .free-product-heading.active").removeClass("active");
//             $(".horizon-product__block-free-product .main-product__block-free-product")
//                 .stop(true, true)
//                 .slideUp(600);
//             $heading.addClass("active");
//             $content.stop(true, true).slideDown(600);
//         }
//     });
// });